import MessageEnvoyer from "./messageEnvoyer";
import React, { useRef, useEffect } from 'react';

const MessageContenu = (props) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const messagesRef = useRef(null);

    useEffect(() => {
      messagesRef.current.scrollTo(0, messagesRef.current.scrollHeight);
    }, [props.messages, props.mess_env]);


    return (
        <div className="content">
        <div className="contact-profile">
        <img src={props.messages[0].logo === '/bel.png' ? '/img/bel.png' : `${apiUrl}/image/equipe/${props.messages[0].logo}`} alt="" />
          <p>{props.messages[0].nom !== null && props.messages[0].prenom !== null ? (<>{props.messages[0].nom} {props.messages[0].prenom}</>):(<>Utilisateur supprimé</>)}</p>
        </div>
        <div className="messages" ref={messagesRef}>
          <ul>
            {props.messages.length > 0 && props.messages[0].message.map((msg, index) => (
                 <li key={index} className={msg.id_expediteur === props.userData.user.donnée.results[0].id ? "replies" : "sent"} >
                    <img 
                      src={
                        (props.userData.user.donnée.results[0].logo && msg.id_expediteur === props.userData.user.donnée.results[0].id) 
                        ? `${apiUrl}/image/equipe/${props.userData.user.donnée.results[0].logo}` 
                        : (props.messages[0].logo === '/bel.png' 
                          ? '/img/bel.png' 
                          : `${apiUrl}/image/equipe/${props.messages[0].logo}`
                        )
                      } 
                      alt="" 
                    />                   
                    <p>{msg.message} </p>
                  </li>
              ))}
            {props.mess_env.length > 0 &&  props.mess_env.map((msg, index) => (
                  <li key={index} className={msg.id_expediteur === props.userData.user.donnée.results[0].id ? "replies" : "sent"} >
                      <img 
                        src={
                          (props.userData.user.donnée.results[0].logo && msg.id_expediteur === props.userData.user.donnée.results[0].id) 
                          ? `${apiUrl}/image/equipe/${props.userData.user.donnée.results[0].logo}` 
                          : (props.messages[0].logo === '/bel.png' 
                            ? '/img/bel.png' 
                            : `${apiUrl}/image/equipe/${props.messages[0].logo}`
                          )
                        } 
                        alt="" 
                      />
                    <p>{msg.message} </p>
                  </li>
              ))}
          </ul>
        </div>
        <MessageEnvoyer sendMessage={props.sendMessage} setMessageInput={props.setMessageInput} messageInput={props.messageInput}/>
      </div>
    )

}



export default MessageContenu; 